import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLeftRightArrow = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 256 256",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 256,
			height: 256,
			fill: "none"
		}),
		/* @__PURE__ */ _jsx("polyline", {
			points: "176 144 208 176 176 208",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 16
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 48,
			y1: 176,
			x2: 208,
			y2: 176,
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 16
		}),
		/* @__PURE__ */ _jsx("polyline", {
			points: "80 112 48 80 80 48",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 16
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 208,
			y1: 80,
			x2: 48,
			y2: 80,
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 16
		})
	]
});
export default SvgLeftRightArrow;
